import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3630e8b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630e8b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3630e8b4')) {
      api.createRecord('3630e8b4', component.options)
    } else {
      api.reload('3630e8b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3630e8b4&scoped=true", function () {
      api.rerender('3630e8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/airTransport/airlinePushRecords/index.vue"
export default component.exports